function maskAadhaar(val) {
    if (!val || val === "-") return "-";
    const digits = val.replace(/\s+/g, "");
    if (/^\d{12}$/.test(digits)) {
        return `XXXX XXXX ${digits.slice(8)}`;
    }
    return "XXXX XXXX XXXX";
}

function formatDate(val) {
    if (!val || val === "-") return "-";
    // Already formatted as DD/MM/YYYY
    if (/^\d{2}\/\d{2}\/\d{4}$/.test(val)) return val;
    const d = new Date(val);
    if (isNaN(d)) return val;
    return `${String(d.getDate()).padStart(2, "0")}/${String(d.getMonth() + 1).padStart(2, "0")}/${d.getFullYear()}`;
}

const ATTACHMENT_LABELS = {
    1: "Medical Certificate",
    3: "DOB Proof",
    6: "DOD Proof",
};

function ClaimViewModal({ claim, onClose }) {
    if (!claim) return null;

    const loan = claim.loan || {};
    const claimData = claim.claim || {};

    return (
        <div className="modal d-block" tabIndex="-1" style={{ backgroundColor: "rgba(0,0,0,0.5)" }}>
            <div className="modal-dialog modal-lg modal-dialog-scrollable">
                <div className="modal-content">
                    <div className="modal-header" style={{ backgroundColor: "#eaf4f0" }}>
                        <h5 className="modal-title" style={{ color: "#1a5c4a", fontWeight: "700" }}>
                            {claim.claimType} Claim — {claim.id}
                        </h5>
                        <button type="button" className="btn-close" onClick={onClose}></button>
                    </div>
                    <div className="modal-body">
                        {/* Loan Details */}
                        <h6 style={{ color: "#1a5c4a", fontWeight: "700" }} className="mb-2">Loan Details</h6>
                        <div className="list-type mb-4">
                            <div className="row">
                                <div className="col-md-3 mb-2">
                                <p className="mb-0 text-muted small">Loanee Full Name</p>
                                <h4 className="mb-0" style={{fontSize:"0.95rem", fontWeight:"600", marginTop:"0", marginBottom:"0"}}>{loan.name}</h4>
                            </div>
                            <div className="col-md-3 mb-2">
                                <p className="mb-0 text-muted small">Aadhaar Number</p>
                                <h4 style={{ wordBreak: "break-all", fontSize: "0.85rem" }}>{maskAadhaar(loan.aadhaar)}</h4>
                            </div>
                            <div className="col-md-3 mb-2">
                                <p className="mb-0 text-muted small">Mobile Number</p>
                                <h4 className="mb-0" style={{fontSize:"0.95rem", fontWeight:"600", marginTop:"0", marginBottom:"0"}}>{loan.mobile}</h4>
                            </div>
                            <div className="col-md-3 mb-2">
                                <p className="mb-0 text-muted small">Loan Number</p>
                                <h4 className="mb-0" style={{fontSize:"0.95rem", fontWeight:"600", marginTop:"0", marginBottom:"0"}}>{loan.loanNo}</h4>
                            </div>
                            <div className="col-md-3 mb-2">
                                <p className="mb-0 text-muted small">Loan Amount</p>
                                <h4 className="mb-0" style={{fontSize:"0.95rem", fontWeight:"600", marginTop:"0", marginBottom:"0"}}>{loan.amount}</h4>
                            </div>
                            <div className="col-md-3 mb-2">
                                <p className="mb-0 text-muted small">Society Membership #</p>
                                <h4 className="mb-0" style={{fontSize:"0.95rem", fontWeight:"600", marginTop:"0", marginBottom:"0"}}>{loan.membership}</h4>
                            </div>
                            <div className="col-md-3 mb-2">
                                <p className="mb-0 text-muted small">Society Name</p>
                                <h4 className="mb-0" style={{fontSize:"0.95rem", fontWeight:"600", marginTop:"0", marginBottom:"0"}}>{loan.society}</h4>
                            </div>
                             <div className="col-md-3 mb-2">
                                <p className="mb-0 text-muted small">Society Address</p>
                                <h4 className="mb-0" style={{fontSize:"0.95rem", fontWeight:"600", marginTop:"0", marginBottom:"0"}}>{loan.societyAddress}</h4>
                            </div>
                            <div className="col-md-3 mb-2">
                                <p className="mb-0 text-muted small">Date of Birth</p>
                                <h4 className="mb-0" style={{fontSize:"0.95rem", fontWeight:"600", marginTop:"0", marginBottom:"0"}}>{loan.dob}</h4>
                            </div>
                            <div className="col-md-3 mb-2">
                                <p className="mb-0 text-muted small">Birth Certificate #</p>
                                <h4 className="mb-0" style={{fontSize:"0.95rem", fontWeight:"600", marginTop:"0", marginBottom:"0"}}>{loan.birthCertificateNumber}</h4>
                            </div>
                            </div>
                        </div>

                        {/* Claim Details */}
                        <h6 style={{ color: "#1a5c4a", fontWeight: "700" }} className="mb-2">{claim.claimType} Claim Details</h6>
                        <div className="list-type mb-4">
                            <div className="row">
                                {claim.claimType === "Disease" ? (
                                    <>
                                        <div className="col-md-3 mb-2">
                                <p className="mb-0 text-muted small">Disease Category</p>
                                <h4 className="mb-0" style={{fontSize:"0.95rem", fontWeight:"600", marginTop:"0", marginBottom:"0"}}>{claimData.diseaseCategoryName || "-"}</h4>
                            </div>
                            <div className="col-md-3 mb-2">
                                <p className="mb-0 text-muted small">Date of Illness</p>
                                <h4 className="mb-0" style={{fontSize:"0.95rem", fontWeight:"600", marginTop:"0", marginBottom:"0"}}>{formatDate(claimData.dateOfIllness)}</h4>
                            </div>
                            <div className="col-md-3 mb-2">
                                <p className="mb-0 text-muted small">Hospital Category</p>
                                <h4 className="mb-0" style={{fontSize:"0.95rem", fontWeight:"600", marginTop:"0", marginBottom:"0"}}>{claimData.hospitalCategoryName}</h4>
                            </div>
                            <div className="col-md-3 mb-2">
                                <p className="mb-0 text-muted small">Medical Cert. Issued by</p>
                                <h4 className="mb-0" style={{fontSize:"0.95rem", fontWeight:"600", marginTop:"0", marginBottom:"0"}}>{claimData.medicalCertificateIssuedBy}</h4>
                            </div>
                            <div className="col-md-3 mb-2">
                                <p className="mb-0 text-muted small">Medical Cert. Date</p>
                                <h4 className="mb-0" style={{fontSize:"0.95rem", fontWeight:"600", marginTop:"0", marginBottom:"0"}}>{formatDate(claimData.dateOfMedicalCertificate)}</h4>
                            </div>
                                    </>
                                ) : (
                                    <>
                                        <div className="col-md-3 mb-2">
                                <p className="mb-0 text-muted small">Claimant Name</p>
                                <h4 className="mb-0" style={{fontSize:"0.95rem", fontWeight:"600", marginTop:"0", marginBottom:"0"}}>{claimData.claimantName}</h4>
                            </div>
                            <div className="col-md-3 mb-2">
                                <p className="mb-0 text-muted small">Relationship to Loanee</p>
                                <h4 className="mb-0" style={{fontSize:"0.95rem", fontWeight:"600", marginTop:"0", marginBottom:"0"}}>{claimData.relationshipName}</h4>
                            </div>
                            {claimData.relationshipName==="Other" &&(
                                <div className="col-md-3 mb-2">
                                <p className="mb-0 text-muted small">Specify Relationship</p>
                                <h4 className="mb-0" style={{fontSize:"0.95rem", fontWeight:"600", marginTop:"0", marginBottom:"0"}}>{claimData.otherRelationship}</h4>
                            </div>
                            )}
                            <div className="col-md-3 mb-2">
                                <p className="mb-0 text-muted small">Date of Death</p>
                                <h4 className="mb-0" style={{fontSize:"0.95rem", fontWeight:"600", marginTop:"0", marginBottom:"0"}}>{formatDate(claimData.dateOfDeath)}</h4>
                            </div>
                            <div className="col-md-3 mb-2">
                                <p className="mb-0 text-muted small">Death Certificate #</p>
                                <h4 className="mb-0" style={{fontSize:"0.95rem", fontWeight:"600", marginTop:"0", marginBottom:"0"}}>{claimData.deathCertNumber}</h4>
                            </div>
                            <div className="col-md-3 mb-2">
                                <p className="mb-0 text-muted small" style={{marginBottom:"0"}}>Prev. Disease Relief</p>
                                <h4 className="mb-0" style={{fontSize:"0.95rem", fontWeight:"600", marginTop:"0", marginBottom:"0"}}>{claimData.previousDiseaseRelief}</h4>
                            </div>
                            {claimData.previousDiseaseRelief === "yes" && (
                            <div className="col-md-3 mb-2">
                                <p className="mb-0 text-muted small" style={{marginBottom:"0"}}>Release Amount</p>
                                <h4 className="mb-0" style={{fontSize:"0.95rem", fontWeight:"600", marginTop:"0", marginBottom:"0"}}>{claimData.releaseAmount}</h4>
                            </div>
                            )}
                                    </>
                                )}
                            </div>
                        </div>

                    {/* Attachments */}
                    {claim.attachments?.length > 0 && (
                        <>
                            <h6 style={{ color: "#1a5c4a", fontWeight: "700" }} className="mb-2">Uploaded Documents</h6>
                            <div className="list-type mb-4">
                                <div className="row">
                                    {claim.attachments.map((a, i) => (
                                        <div key={i} className="col-md-4 mb-2">
                                            <p className="mb-0 text-muted small">{ATTACHMENT_LABELS[a.type] || a.fileName}</p>
                                            <a href={a.url} target="_blank" rel="noopener noreferrer" style={{ color: "#1a5c4a", fontSize: "0.9rem" }}>
                                                <i className="fa fa-file me-1"></i> View
                                            </a>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </>
                    )}
                </div>
                </div>
            </div>
        </div>
    );
}

export default ClaimViewModal;
